import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box
} from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';

interface CameraMissingDialogProps {
  open: boolean;
  onClose: () => void;
  missingCameraId: string;
  experimentId: string;
}

const CameraMissingDialog: React.FC<CameraMissingDialogProps> = ({
  open,
  onClose,
  missingCameraId,
  experimentId
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <WarningIcon sx={{ color: 'warning.main' }} />
        Camera Not Found
      </DialogTitle>
      
      <DialogContent>
        <Box sx={{ mb: 2 }}>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Camera <strong>{missingCameraId}</strong> is not connected but is configured in experiment <strong>{experimentId}</strong>.
          </Typography>
          
          <Typography variant="body1" sx={{ fontWeight: 'bold', color: 'text.secondary' }}>
            Please refresh cameras and edit the experiment.
          </Typography>
        </Box>
      </DialogContent>
      
      <DialogActions>
        <Button onClick={onClose} variant="contained">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CameraMissingDialog;
